var ua = navigator.userAgent || '';
export var mobileOs = (function () {
    var lowerCaseUa = ua.toLowerCase();
    if (lowerCaseUa.indexOf('android') !== -1) {
        return 'android';
    }
    if (lowerCaseUa.indexOf('iphone') !== -1 || lowerCaseUa.indexOf('ipad') !== -1) {
        return 'ios';
    }
    return 'other';
})();
export var isMobile = /\bmobile\b/i.test(ua);
export var isPC = !!ua.length && !isMobile;
export var isAndroid = isMobile && /\bandroid\b/i.test(ua);
export var isIos = isMobile && /\bmac os\b/i.test(ua);
export var isChrome = /Chrome/.test(ua) && /Google Inc/.test(navigator.vendor);
export var isElectron = /\belectron\b/i.test(ua);
